import { type LicitacionDetalleResponse } from './api.schema';
import { type LicitacionDetalleUI } from './ui.schema';

export { 
  LicitacionDetalleResponseSchema,
  type LicitacionDetalleResponse,
  type LicitacionDetalleData,
  type ArchivoLicitacion,
  type PreguntaRespuestaLicitacion
} from './api.schema';

export { 
  LicitacionDetalleUISchema,
  type LicitacionDetalleUI 
} from './ui.schema';

export const transformLicitacionDetalleApiToUi = (data: LicitacionDetalleResponse): LicitacionDetalleUI => {
  const jsonMetadata = data.data.json_metadata;
  console.log("📦 [Transform] tematica_id crudo recibido de la API:", data.data.tematica_id);
  
  return {
    id: data.data.id,
    nombre: data.data.nombre,
    tematica_id: data.data.tematica_id,
    resumen: data.data.resumen,
    resumen_llm: data.data.resumen_llm,
    criterios_evaluacion: data.data.criterios_evaluacion || null,
    codigo_externo: data.data.codigo_externo,
    url_ficha_oficial: data.data.url_ficha_oficial || null,
    codigo_estado: data.data.codigo_estado,
    estado_licitacion: data.data.estado_licitacion,
    fecha_creacion: data.data.fecha_creacion,
    fecha_cierre: data.data.fecha_cierre,
    puntaje: data.data.puntaje,
    puntaje_archivos: data.data.puntaje_archivos,
    resumen_archivos_llm: data.data.resumen_archivos_llm,
    requisitos_postulacion: data.data.requisitos_postulacion,
    archivos: data.archivos,
    preguntas_y_respuestas: data.preguntas_y_respuestas,
    visto: data.visto,
    estado_notificacion: data.data.estado_notificacion,
    fecha_actualizacion: data.data.fecha_actualizacion,
    monto_estimado: jsonMetadata?.MontoEstimado || null,
    moneda: jsonMetadata?.Moneda || 'CLP',
    tiempo_duracion_contrato: jsonMetadata?.TiempoDuracionContrato || null,
    responsable_contrato: jsonMetadata?.NombreResponsableContrato || null,
    responsable_pago: jsonMetadata?.NombreResponsablePago || null,
    descripcion_licitacion: jsonMetadata?.Descripcion || null,
    resumen_procesado_filtro_palabras: data.data.resumen_procesado_filtro_palabras,
    archivos_procesados: data.data.archivos_procesados,
    resumen_procesado_filtro_llm: data.data.resumen_procesado_filtro_llm,
    postulado: data.data.postulado,
    adjudicado: data.data.adjudicado,
    fecha_postulacion: data.data.fecha_postulacion,
    fecha_adjudicacion: data.data.fecha_adjudicacion,
    resumen_general: data.data.resumen_general,
    fuentes_resumen_general: data.data.fuentes_resumen_general,
    json_metadata: jsonMetadata,
    contenido_ficha: data.data.contenido_ficha || null
  };
}; 